export default __webpack_public_path__ + "static/media/Thief's Armbands of Engulfing Twilight.6cc57482.jpg";